module.exports = __webpack_public_path__ + "img/documents.9a125f23.jpg";